import * as React from 'react';
import classnames from 'classnames';

import UnderageLegalWarning from 'modules/influencers/components/legal-warning/UnderageLegalWarning';

import ProfileName from '../../../components/profile-name/ProfileName';
import ProfileArtistName from '../../../components/profile-artist-name/ProfileArtistName';
import ProfileDateOfBirth from '../../../components/profile-date-of-birth/ProfileDateOfBirth';
import ProfileGender from '../../../components/profile-gender/ProfileGender';
import ProfileLocation from '../../../components/profile-location/ProfileLocation';
import ProfileAgency from '../../../components/profile-agency/ProfileAgency';

import './profile-main-information-fields.scss';

import type { InfluencerProfileForm } from 'types';

interface Props {
  profile: InfluencerProfileForm,
  hasError: boolean,
  isTalentAgencyManaged?: boolean,
  onChange: (profile: Partial<InfluencerProfileForm>) => void
}

const ProfileMainInformationFields: React.FC<Props> = ({
  profile,
  hasError,
  isTalentAgencyManaged,
  onChange
}) => {
  const renderAgeWarning = (): React.ReactNode => {
    const ageWarningClasses = classnames('profile-main-information-fields__age-warning', {
      'profile-main-information-fields__age-warning--error': hasError
    });

    return (
      <UnderageLegalWarning
        dateOfBirth={profile.influencerDateOfBirth}
        className={ageWarningClasses}
      />
    );
  };

  return (
    <div className="profile-main-information-fields">
      <ProfileName
        profile={profile}
        onChange={onChange}
      />
      <ProfileArtistName
        profile={profile}
        onChange={onChange}
      />
      <div>
        <div className="profile-main-information-fields__section">
          <ProfileDateOfBirth
            profile={profile}
            onChange={onChange}
          />
          <ProfileGender
            profile={profile}
            onChange={onChange}
          />
        </div>
        {renderAgeWarning()}
      </div>
      <ProfileLocation
        profile={profile}
        onChange={onChange}
      />
      {
        !isTalentAgencyManaged && !profile.influencersAgencyId && (
          <ProfileAgency
            profile={profile}
            onChange={onChange}
          />
        )
      }
    </div>
  );
};

export default ProfileMainInformationFields;
